import axios from "axios";

export interface PincodeDetails {
  city: string | null;
  state: string | null;
}

export const getPincodeDetails = async (
  pincode: string,
): Promise<PincodeDetails | null> => {
  if (!pincode || pincode.length !== 6) return null;

  try {
    const response = await axios.get(
      `https://api.postalpincode.in/pincode/${pincode}`,
    );

    if (response.data && response.data[0]?.Status === "Success") {
      const postOffice = response.data[0].PostOffice?.[0];
      if (postOffice) {
        return {
          city:
            postOffice.District || postOffice.Block || postOffice.Name || null,
          state: postOffice.State || null,
        };
      }
    }

    return null;
  } catch (error) {
    console.error("Error fetching location details from pincode:", error);
    return null;
  }
};

export const getStateFromPincode = async (
  pincode: string,
): Promise<string | null> => {
  const details = await getPincodeDetails(pincode);
  return details?.state || null;
};
